import { PLATFORM_MAP } from '~/modules/artist-roster/pages/artist-details/pages/media-planner/constants';

// We have a total of 24 data colors defined in our CSS in
// container/src/styles/theme-whitelabel.css
export const totalDataColors = 24;

function getCssColorValue(color: number) {
  return `oklch(var(--data-color-${color.toString().padStart(2, '0')}))`;
}

export function getPlatformSliceColor(name: keyof typeof PLATFORM_MAP) {
  const colorIndex = PLATFORM_MAP[name].dataColor;

  return getCssColorValue(colorIndex);
}

export function getMarketSliceColor(index: number) {
  const colorIndex = (index % totalDataColors) + 1;

  return getCssColorValue(colorIndex);
}
